import React from "react";
import ContactSmallIcon from "./../../assets/headernewlogo2.png";
import { useTranslation } from "react-i18next";
const FAQBtn = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="card mb-3">
        <div className="row g-0">
          <div className="col-md-3 p-3 bg-light">
            <img
              src={ContactSmallIcon}
              width={150}
              loading="lazy"
              className="img-fluid rounded-start"
              alt="Logo"
            />
          </div>
          <div className="col-md-9">
            <div className="card-body mt-2">
              <p className="fs-14 mb-0">{t("FAQTitle")}</p>
              <a href="./faq" className="text-dark fs-11">
                {t("FAQLink")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQBtn;
